import { useTranslation } from 'react-i18next'
import { useWindow } from 'hooks/use.window'
import { allowStorage } from 'utils/allow.storage'

export const StorageDisabledWarning: React.FC = () => {
  const { t } = useTranslation()
  const window = useWindow()

  if (!window || allowStorage()) {
    return null
  }

  return (
    <a href={window.location.href} target={'_blank'} rel="noreferrer" style={{
      background: 'red',
      color: 'white',
      display: 'block',
      fontSize: 30,
      left: 0,
      padding: 30,
      position: 'fixed',
      right: 0,
      textAlign: 'center',
      top: 0,
      zIndex: 999999,
    }}>
      {t('error-within-iframe', 'You seem to be opening Tucan within an iframe. Please open Tucan.ai directly!')}
    </a>
  )
}
